/*
 * @Descripttion: 漏斗图 json
 * @version:
 * @Author: leo.liu
 * @Date: 2021-08-29 07:29:23
 * @LastEditors: qianlishi
 * @LastEditTime: 2021-09-28 14:12:37
 */
export const widgetFunnel = {
  code: "widget-funnel",
  type: "chart",
  label: "漏斗图",
  icon: "icon-loudoutu",
  options: {
    // 配置
    setup: [
      {
        type: "el-input-text",
        label: "标题名称",
        name: "titleText",
        required: false,
        placeholder: "",
        value: "",
      },
      {
        type: "vue-color",
        label: "标题颜色",
        name: "textColor",
        required: false,
        placeholder: "",
        dark: "#FFFFFF",
        value: "#13234C",
      },
      {
        type: "el-input-number",
        label: "标题字号",
        name: "textFontSize",
        required: false,
        placeholder: "",
        value: 16,
      },
      {
        type: "el-select",
        label: "标题对齐",
        name: "textAlign",
        required: false,
        placeholder: "",
        selectOptions: [
          { code: "center", name: "居中" },
          { code: "left", name: "左对齐" },
          { code: "right", name: "右对齐" },
        ],
        value: 'left',
      },
      // {
      //   type: "el-input-text",
      //   label: "图层名称",
      //   name: "layerName",
      //   required: false,
      //   placeholder: "",
      //   value: "漏斗图",
      // },
      {
        type: "vue-color",
        label: "背景颜色",
        name: "background",
        required: false,
        placeholder: "",
        dark: "#262626",
        value: "#fff",
      },
      {
        type: "vue-color",
        label: "图例文字颜色",
        name: "lengedColor",
        required: false,
        placeholder: "",
        dark: "#FFFFFF",
        value: "#677392",
      },
      {
        type: "el-switch",
        label: "翻转",
        name: "ending",
        require: false,
        placeholder: "",
        value: false,
      },
    ],
    // 数据
    data: [
      {
        type: "el-radio-group",
        label: "数据类型",
        name: "dataType",
        require: false,
        placeholder: "",
        selectValue: true,
        selectOptions: [
          {
            code: "staticData",
            name: "静态数据",
          },
          {
            code: "dynamicData",
            name: "动态数据",
          },
        ],
        value: "dynamicData",
      },
      // {
      //   type: "el-input-number",
      //   label: "刷新时间(毫秒)",
      //   name: "refreshTime",
      //   relactiveDom: "dataType",
      //   relactiveDomValue: "dynamicData",
      //   value: 5000,
      // },
      {
        type: "el-button",
        label: "静态数据",
        name: "staticData",
        required: false,
        placeholder: "",
        relactiveDom: "dataType",
        relactiveDomValue: "staticData",
        value: [
          { value: 2, name: "访问" },
          { value: 5, name: "咨询" },
          { value: 20, name: "订单" },
          { value: 40, name: "点击" },
          { value: 125, name: "展现" },
        ],
      },
      {
        type: "dycustComponents",
        label: "",
        name: "dynamicData",
        required: false,
        placeholder: "",
        relactiveDom: "dataType",
        chartType: "widget-funnel",
        relactiveDomValue: "dynamicData",
        dictKey: "FUNNEL_PROPERTIES",
        value: {},
      },
    ],
    // 坐标
    position: [
      {
        type: "el-input-number",
        label: "左边距",
        name: "left",
        required: false,
        placeholder: "",
        value: 0,
      },
      {
        type: "el-input-number",
        label: "上边距",
        name: "top",
        required: false,
        placeholder: "",
        value: 0,
      },
      {
        type: "el-input-number",
        label: "宽度",
        name: "width",
        required: false,
        placeholder: "该容器在1920px大屏中的宽度",
        value: 250,
      },
      {
        type: "el-input-number",
        label: "高度",
        name: "height",
        required: false,
        placeholder: "该容器在1080px大屏中的高度",
        value: 310,
      },
    ],
  },
};
